import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import type { SidebarItem } from '../../components/app/layout/Sidebar'

interface SidebarState {
  items: SidebarItem[]
  expandedItems: string[]
  selectedCaseId: string | null
}

const initialState: SidebarState = {
  items: [
    // Always show All Documents section
    {
      id: 'all-documents',
      label: 'All Documents',
      iconName: 'Folder',
      type: 'folder',
      metadata: { isGlobal: true, count: 0 },
      children: []
    }
    // {
    //   id: 'case-maria-gonzalez-2025',
    //   label: 'Maria Gonzalez',
    //   iconName: 'FolderOpen',
    //   type: 'case',
    //   status: 'processing',
    //   metadata: {
    //     caseId: 'MG-2025-001',
    //     date: '2025-01-15',
    //     fullName: 'Maria Gonzalez - Mortgage Application'
    //   },
    //   children: [
    //     // Single-page categories
    //     { id: 'financial-summary', label: 'Summary', iconName: 'FileCheck', type: 'summary' },
    //     { id: 'financial-insights', label: 'Insights', iconName: 'MessageSquare', type: 'summary' },

    //     // Income category (expandable)
    //     {
    //       id: 'income-folder',
    //       label: 'Income',
    //       iconName: 'Folder',
    //       type: 'folder',
    //       children: [
    //         { id: 'income-w2', label: 'W2', iconName: 'FileSpreadsheet', type: 'summary' },
    //         { id: 'income-paystubs', label: 'Paystubs', iconName: 'FileSpreadsheet', type: 'summary' },
    //         { id: 'income-other', label: 'Other Income', iconName: 'FileSpreadsheet', type: 'summary' }
    //       ]
    //     },

    //     // Assets (expandable)
    //     {
    //       id: 'assets-folder',
    //       label: 'Assets',
    //       iconName: 'Folder',
    //       type: 'folder',
    //       children: [
    //         { id: 'assets-bank', label: 'Bank Accounts', iconName: 'Database', type: 'summary' },
    //         { id: 'assets-investments', label: 'Investments', iconName: 'Database', type: 'summary' },
    //         { id: 'assets-realestate', label: 'Real Estate', iconName: 'Database', type: 'summary' }
    //       ]
    //     },

    //     // Collateral (expandable)
    //     {
    //       id: 'collateral-folder',
    //       label: 'Collateral',
    //       iconName: 'Folder',
    //       type: 'folder',
    //       children: [
    //         { id: 'collateral-property', label: 'Property Details', iconName: 'Folder', type: 'summary' },
    //         { id: 'collateral-appraisal', label: 'Appraisal', iconName: 'Folder', type: 'summary' }
    //       ]
    //     },

    //     // Capacity (expandable)
    //     {
    //       id: 'capacity-folder',
    //       label: 'Capacity',
    //       iconName: 'Folder',
    //       type: 'folder',
    //       children: [
    //         { id: 'capacity-dti', label: 'Debt-to-Income', iconName: 'Hash', type: 'summary' },
    //         { id: 'capacity-reserves', label: 'Reserves', iconName: 'Hash', type: 'summary' }
    //       ]
    //     },

    //     // Documents with extracts under each document
    //     {
    //       id: 'documents-folder',
    //       label: 'Documents',
    //       iconName: 'Folder',
    //       type: 'folder',
    //       metadata: { count: 4 },
    //       children: [
    //         { 
    //           id: 'maria-jan-stmt', 
    //           label: 'Bank Statement - Jan 2025', 
    //           iconName: 'FileText',
    //           type: 'file',
    //           status: 'complete',
    //           metadata: { documentId: '__DEV_TEST__' },
    //           children: [
    //             { id: 'extract-jan-stmt', label: 'Extraction', iconName: 'Hash', type: 'extract', status: 'complete' }
    //           ]
    //         },
    //         { 
    //           id: 'maria-feb-stmt', 
    //           label: 'Bank Statement - Feb 2025', 
    //           iconName: 'FileText',
    //           type: 'file',
    //           status: 'complete',
    //           metadata: { documentId: '__DEV_TEST__' },
    //           children: [
    //             { id: 'extract-feb-stmt', label: 'Extraction', iconName: 'Hash', type: 'extract', status: 'complete' }
    //           ]
    //         },
    //         { 
    //           id: 'maria-w2-2023', 
    //           label: 'W2 Form - 2023', 
    //           iconName: 'FileSpreadsheet',
    //           type: 'file',
    //           status: 'complete',
    //           metadata: { documentId: '__DEV_TEST__' },
    //           children: [
    //             { id: 'extract-w2-2023', label: 'Extraction', iconName: 'Hash', type: 'extract', status: 'complete' }
    //           ]
    //         },
    //         { 
    //           id: 'maria-w2-2024', 
    //           label: 'W2 Form - 2024', 
    //           iconName: 'FileSpreadsheet',
    //           type: 'file',
    //           status: 'complete',
    //           metadata: { documentId: '__DEV_TEST__' },
    //           children: [
    //             { id: 'extract-w2-2024', label: 'Extraction', iconName: 'Hash', type: 'extract', status: 'processing' }
    //           ]
    //         }
    //       ]
    //     },

    //     // Flags (keep as separate expandable group)
    //     {
    //       id: 'flags-folder',
    //       label: 'Red Flags',
    //       iconName: 'AlertCircle',
    //       type: 'folder',
    //       metadata: { count: 2 },
    //       children: [
    //         { id: 'flag-balance', label: 'Balance Discrepancy', iconName: 'AlertCircle', type: 'flag', status: 'pending' },
    //         { id: 'flag-duplicate', label: 'Duplicate Transaction', iconName: 'AlertCircle', type: 'flag', status: 'pending' }
    //       ]
    //     }
    //   ]
    // },
    // {
    //   id: 'case-john-smith-2025',
    //   label: 'John Smith',
    //   iconName: 'Folder',
    //   type: 'case',
    //   status: 'complete',
    //   metadata: {
    //     caseId: 'JS-2025-002',
    //     date: '2025-01-10',
    //     fullName: 'John Smith - Auto Loan'
    //   },
    //   children: []
    // }
  ],
  expandedItems: [],
  selectedCaseId: null
}

const sidebarSlice = createSlice({
  name: 'sidebar',
  initialState,
  reducers: {
    setSidebarItems: (state, action: PayloadAction<SidebarItem[]>) => {
      state.items = action.payload
    },
    addSidebarItem: (state, action: PayloadAction<SidebarItem>) => {
      state.items.push(action.payload)
    },
    updateSidebarItem: (state, action: PayloadAction<{ id: string; updates: Partial<SidebarItem> }>) => {
      const { id, updates } = action.payload
      const updateItem = (items: SidebarItem[]): SidebarItem[] => {
        return items.map(item => {
          if (item.id === id) {
            return { ...item, ...updates }
          }
          if (item.children) {
            return { ...item, children: updateItem(item.children) }
          }
          return item
        })
      }
      state.items = updateItem(state.items)
    },
    removeSidebarItem: (state, action: PayloadAction<string>) => {
      const removeItem = (items: SidebarItem[]): SidebarItem[] => {
        return items.filter(item => {
          if (item.id === action.payload) {
            return false
          }
          if (item.children) {
            item.children = removeItem(item.children)
          }
          return true
        })
      }
      state.items = removeItem(state.items)
    },
    toggleExpand: (state, action: PayloadAction<string>) => {
      const itemId = action.payload
      const idx = state.expandedItems.indexOf(itemId)
      if (idx >= 0) {
        state.expandedItems.splice(idx, 1)
      } else {
        state.expandedItems.push(itemId)
      }
    },
    setExpandedItems: (state, action: PayloadAction<string[]>) => {
      state.expandedItems = action.payload
    },
    setSelectedCaseId: (state, action: PayloadAction<string | null>) => {
      state.selectedCaseId = action.payload
      // Auto-expand the selected case root when a case is chosen
      if (action.payload) {
        const caseItem = state.items.find(i => i.type === 'case' && i.metadata?.caseId === action.payload)
        if (caseItem) {
          if (!state.expandedItems.includes(caseItem.id)) {
            state.expandedItems.push(caseItem.id)
          }
        }
      }
    },
    addDocumentToCase: (state, action: PayloadAction<{ 
      caseId?: string | null, 
      document: { 
        id: string, 
        label: string, 
        documentId: string,
        status?: 'pending' | 'processing' | 'complete' | 'error'
      } 
    }>) => {
      const { caseId, document } = action.payload
      
      // Always add to All Documents section
      const allDocsSection = state.items.find(item => item.id === 'all-documents')
      if (allDocsSection) {
        // Check if document already exists in All Documents
        if (!allDocsSection.children?.find(child => child.metadata?.documentId === document.documentId)) {
          const newDoc: SidebarItem = {
            id: document.id,
            label: document.label,
            iconName: 'FileText',
            type: 'file',
            status: document.status || 'processing',
            metadata: { documentId: document.documentId }
          }
          
          if (!allDocsSection.children) {
            allDocsSection.children = []
          }
          allDocsSection.children.push(newDoc)
          
          // Update count
          if (allDocsSection.metadata) {
            allDocsSection.metadata.count = allDocsSection.children.length
          }
        }
      }
      
      // Also add to case if caseId is provided
      if (caseId) {
        const caseItem = state.items.find(item => item.metadata?.caseId === caseId)
        if (caseItem) {
          // Find or create documents folder
          let docsFolder = caseItem.children?.find(child => child.id === 'documents-folder')
          if (!docsFolder) {
            docsFolder = {
              id: 'documents-folder',
              label: 'Documents',
              iconName: 'Folder',
              type: 'folder',
              metadata: { count: 0 },
              children: []
            }
            if (!caseItem.children) {
              caseItem.children = []
            }
            caseItem.children.push(docsFolder)
          }
          
          // Add document if not already present
          if (!docsFolder.children?.find(child => child.metadata?.documentId === document.documentId)) {
            const newDoc: SidebarItem = {
              id: `${caseId}-${document.id}`,
              label: document.label,
              iconName: 'FileText',
              type: 'file',
              status: document.status || 'processing',
              metadata: { documentId: document.documentId }
            }
            
            if (!docsFolder.children) {
              docsFolder.children = []
            }
            docsFolder.children.push(newDoc)
            
            // Update count
            if (docsFolder.metadata) {
              docsFolder.metadata.count = docsFolder.children.length
            }
          }
        }
      }
    },
    removeDocument: (state, action: PayloadAction<{ documentId: string }>) => {
      const { documentId } = action.payload
      
      // Remove from All Documents section
      const allDocsSection = state.items.find(item => item.id === 'all-documents')
      if (allDocsSection?.children) {
        allDocsSection.children = allDocsSection.children.filter(
          child => child.metadata?.documentId !== documentId
        )
        // Update count
        if (allDocsSection.metadata) {
          allDocsSection.metadata.count = allDocsSection.children.length
        }
      }
      
      // Remove from any case
      state.items.forEach(caseItem => {
        if (caseItem.id !== 'all-documents') {
          const docsFolder = caseItem.children?.find(child => child.id === 'documents-folder')
          if (docsFolder?.children) {
            docsFolder.children = docsFolder.children.filter(
              child => child.metadata?.documentId !== documentId
            )
            // Update count
            if (docsFolder.metadata) {
              docsFolder.metadata.count = docsFolder.children.length
            }
          }
        }
      })
    },
    updateDocumentStatus: (state, action: PayloadAction<{
      documentId: string,
      status: 'pending' | 'processing' | 'complete' | 'error'
    }>) => {
      const { documentId, status } = action.payload
      
      // Update in All Documents section
      const allDocsSection = state.items.find(item => item.id === 'all-documents')
      if (allDocsSection?.children) {
        const doc = allDocsSection.children.find(child => child.metadata?.documentId === documentId)
        if (doc) {
          doc.status = status
        }
      }
      
      // Also update in any case
      state.items.forEach(caseItem => {
        if (caseItem.id !== 'all-documents') {
          const docsFolder = caseItem.children?.find(child => child.id === 'documents-folder')
          if (docsFolder?.children) {
            const doc = docsFolder.children.find(child => child.metadata?.documentId === documentId)
            if (doc) {
              doc.status = status
            }
          }
        }
      })
    }
  }
})

export const {
  setSidebarItems,
  addSidebarItem,
  updateSidebarItem,
  removeSidebarItem,
  toggleExpand,
  setExpandedItems,
  setSelectedCaseId,
  addDocumentToCase,
  removeDocument,
  updateDocumentStatus
} = sidebarSlice.actions

export default sidebarSlice.reducer

// Selectors
export const selectSidebarItems = (state: { sidebar: SidebarState }) => state.sidebar.items
export const selectSidebarExpandedItems = (state: { sidebar: SidebarState }) => state.sidebar.expandedItems
export const selectSidebarSelectedCaseId = (state: { sidebar: SidebarState }) => state.sidebar.selectedCaseId
